'use es6';

const THIRTY_DAYS = 2592000;
const PATH = '/affiliate-marketing-external/v1/attribution/store';
export default function attribute(ire, location, document, enviro) {
  if (typeof ire === 'function') {
    ire('identify', {
      customerId: '',
      customerEmail: ''
    });
  }
  const irclickidMatch = location.search.match(/[?|&]irclickid=([^&$]+)/);
  const mpidMatch = location.search.match(/[?|&]mpid=([^&$]+)/);
  const irclickid = irclickidMatch && irclickidMatch[1];
  const mpid = mpidMatch && mpidMatch[1];
  if (irclickid && mpid) {
    const domain = `hubspot${enviro && enviro.isQa() ? 'qa' : ''}.com`;
    if (location.host.match(`${domain}$`)) {
      document.cookie = `IR_ids=${irclickid}|${mpid}; Max-Age=${THIRTY_DAYS}; Domain=${domain}; Path=/; SameSite=None; Secure`;
    } else {
      const request = new XMLHttpRequest();
      request.open('POST', `https://api.${domain}${PATH}`);
      request.withCredentials = true;
      request.setRequestHeader('Content-Type', 'application/json');
      request.send(JSON.stringify({
        visitorId: decodeURIComponent(irclickid),
        affiliateId: mpid
      }));
    }
  }
}